"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/extensions */
/* eslint-disable prettier/prettier */
const react_1 = __importDefault(require("react"));
const logo_1 = __importDefault(require("../../logo"));
const searcher_1 = __importDefault(require("../../searcher"));
const menu_1 = __importDefault(require("../../menu"));
const user_pill_1 = __importDefault(require("../../user-pill"));
const Header1Main = (props) => {
    const { logged, userName, userType, mainOptions, segmentMenu, burgerSections, contextLoaded, burgerOptions, rehidrate, accountSections, } = props;
    const selector = logged ? "logged" : "default";
    return (react_1.default.createElement("div", { className: "header1-main container" },
        react_1.default.createElement("div", { className: "menu" },
            react_1.default.createElement(menu_1.default, { layout: "burguer", items: burgerSections[selector], segmentMenu: segmentMenu[selector], options: burgerOptions[selector], account: accountSections })),
        react_1.default.createElement("div", { className: "logo" },
            react_1.default.createElement(logo_1.default, null)),
        react_1.default.createElement("div", { className: "searcher" },
            react_1.default.createElement(searcher_1.default, { needOpenModalResults: true })),
        react_1.default.createElement("div", { className: "options" }, rehidrate >= 0 && contextLoaded && (react_1.default.createElement(menu_1.default, { items: mainOptions[selector], layout: "icons", location: "all" }))),
        rehidrate >= 0 && contextLoaded && logged && react_1.default.createElement(user_pill_1.default, { userName: userName, userType: userType, items: accountSections })));
};
exports.default = Header1Main;
//# sourceMappingURL=index.js.map